var map = {
	"./acabo-de-llegar-a-barcelona.svg": 4660,
	"./busco-empleo.svg": 4350,
	"./covid-19.png": 1195,
	"./necesito-apoyo.svg": 1295,
	"./otros.svg": 5508,
	"./quiero-conocer-mis-derechos-y-deberes-laborales.svg": 5144,
	"./quiero-cuidarme.svg": 621,
	"./quiero-formarme.svg": 8890,
	"./recursos-para-el-cuidado.svg": 7359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9526;